import { ReactNode } from 'react';

import type { ReaderTheme } from 'shared-types';

interface Props {
  children: ReactNode;
  readerTheme: ReaderTheme;
}

const ReaderSidebarContent = ({ children, readerTheme }: Props) => (
  <div className="content">
    {children}

    <style jsx>{`
      .content {
        color: ${readerTheme.sidebarColor};
        flex-grow: 1;
        height: 100%;
        overflow-y: auto;
      }
    `}</style>
  </div>
);

export default ReaderSidebarContent;
